"use strict";
exports.__esModule = true;
exports.Filter = void 0;
var Filter;
(function (Filter) {
    Filter["Category"] = "category";
    Filter["Localization"] = "region";
    Filter["Thematic"] = "thematic";
    Filter["DateRange"] = "dateRange";
})(Filter = exports.Filter || (exports.Filter = {}));
//# sourceMappingURL=filter.js.map